module.exports = __webpack_public_path__ + "static/img/4diamond-tag@3x.3d30811b.png";